import { ObjectUtils } from '@shared/utils/object.utils';
import { KeyMap } from './KeyMap';

export abstract class Model<T> {

    constructor(values?: KeyMap<T>) {
        if (values) {
            for (const key in values) {
                this[key as string] = values[key];
            }
        }
    }

    public equals(compareTo: T): boolean {
        return ObjectUtils.equals<any>(this, compareTo);
    }

    public sort(compareTo: T): number {
        return 0;
    }

    public abstract get narration(): string;

}

export function HiddenProperty(realPropName: string): PropertyDecorator {
    return function (target: any, propName: string) {
        const get = function () {
            return this[realPropName];
        };
        const set = function (value: unknown) {
            this[realPropName] = value;
        };
        Object.defineProperty(target, propName, { get, set });
    };
}
